module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国出版局旧址.3fa0ac22.png";